module.exports = __webpack_public_path__ + "static/media/tray1.7fa23ca2.png";